import React from "react";

import PageName from "../../shared/components/PageName";
import DataTable from "../../shared/components/table/DataTable";

import { studentsData } from "../../../home/topStudents/utils/studentsData";
import { convertToExcel } from "../../shared/utils/convertToExcel";
import { formatToExcelTableShapeForStudent } from "../../shared/utils/excelShapeFormat";

const StudentsPage = () => {
  const columns = [
    {
      title: "#",
      dataIndex: "id",
      width: "5%",
      editable: false,
    },
    {
      title: "Name",
      dataIndex: "name",
      width: "30%",
      editable: true,
    },
    {
      title: "Lastname",
      dataIndex: "lastName",
      width: "30%",
      editable: true,
    },
    {
      title: "Grade",
      dataIndex: "grade",
      width: "20%",
      editable: true,
    },
  ];

  return (
    <div>
      <PageName
        pageName="Students"
        totalRecords={studentsData}
        excelExport={() =>
          convertToExcel(formatToExcelTableShapeForStudent(studentsData))
        }
      />
      <DataTable tableData={studentsData} columns={columns} />
    </div>
  );
};

export default StudentsPage;
